import { VendedorService } from 'src/app/services/vendedor.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { SaldoDocumentoService } from 'src/app/services/saldo-documento.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from '../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarVendedorComponent } from '../shared/modal-seleccionar-vendedor/modal-seleccionar-vendedor.component';
import { RutService } from 'src/app/shared/services/rut.service';
import * as _ from 'lodash'
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { ModalSeleccionDocumentoAjusteComponent } from '../documento-por-cobrar/modal-seleccion-documento-ajuste/modal-seleccion-documento-ajuste.component';

@Component({
  selector: 'app-documento-por-cobrar',
  templateUrl: './documento-por-cobrar.component.html',
  styleUrls: ['./documento-por-cobrar.component.scss'],
  providers: [SecurityService],
})
export class DocumentoPorCobrarComponent implements OnInit {
  // Constants
  readonly RB_TIPO_VISTA_RESUMEN: String = "_RB_TIPO_VISTA_RESUMEN_"
  readonly RB_TIPO_VISTA_DETALLE: String = "_RB_TIPO_VISTA_DETALLE_"

  // Modales
  //  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarVendedorComponent, { static: true }) modalSeleccionarVendedor: ModalSeleccionarVendedorComponent
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  /** MODAL SELECCIONAR DOCUMENTO **/
  @ViewChild(ModalSeleccionDocumentoAjusteComponent, { static: true }) modalSeleccionarDocumentoAjuste: ModalSeleccionDocumentoAjusteComponent
  // Form
  formHeader: FormGroup

  // Data &  Tmp

  private rutEmpresa: number
  private sucursalEmpresa: number
  private resumen_currentPayload: any = null
  resumen_loading: boolean = false
  resumen_listaMovimientos: Array<any> = null
  resumen_listaMovimientosAll: Array<any> = null
  resumen_paginationContext: PaginationContext = new PaginationContext()
  resumen_totales: any = null

  private detalle_currentPayload: any = null
  detalle_loading: boolean = false
  detalle_listaMovimientos: Array<any> = null
  detalle_listaMovimientosAll: Array<any> = null
  detalle_paginationContext: PaginationContext = new PaginationContext()
  detalle_totales: any = null

  clienteSeleccionado: any = null
  vendedorSeleccionado: any = null
  listaRegistros: any = null
  enableVendedorInputs: boolean = true
  enableClienteInputs: boolean = true
  optionsVendedores: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private rutService: RutService,
    private datesService: DatesService,
    private toastrService: ToastService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private saldoDocumentoService: SaldoDocumentoService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private fileDownloadService: FileDownloadService,
    private vendedorService: VendedorService,

  ) {
    this.log = this.clog.log('CARTOLA-CLIENTE')

  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.resumen_paginationContext.RecordsByPage = 10
    this.detalle_paginationContext.RecordsByPage = 10

    this.loadVendedores();
    this.createForms();
    this.formChangesSubscriptions();
  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      tipoVista: [this.RB_TIPO_VISTA_RESUMEN, [Validators.required]],
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      rutCliente: [''],
      todosClientes: [true],
      agregarFaltantes: [false],
      vendedores: [[]],
      // rutVendedor: [null],
      todosVendedores: [true]
    });
  }


  private formChangesSubscriptions() {
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.log('rutCliente change', rutCliente)
        this.modalSeleccionarCliente.searchByRut(rutCliente)
      })

    // this.formHeader.get("rutVendedor").valueChanges
    //   .pipe(filter(Boolean), debounceTime(1000))
    //   .subscribe((rutVendedor: string) => {
    //     this.modalSeleccionarVendedor.searchByRut(rutVendedor)
    //   })

    /********* MODAL CLIENTE *********/
    // this.formHeader.get("todosClientes").valueChanges
    //   .subscribe((todosClientes: string) => {
    //     this.enableClienteInputs = !todosClientes
    //   })

    // /********* MODAL VENDEDOR *********/
    // this.formHeader.get("todosVendedores").valueChanges
    //   .subscribe((todosVendedores: string) => {
    //     this.enableVendedorInputs = !todosVendedores
    //   })
  }

  /********* MODAL CLIENTE *********/
  abrirModalSeleccionarCliente() {
    this.formHeader.get('todosClientes').setValue(false)
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data, origen }) {
    this.clienteSeleccionado = data
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(this.clienteSeleccionado.rut)
    this.log('this.clienteSeleccionado', this.clienteSeleccionado)
    this.formHeader.get('rutCliente').setValue(this.clienteSeleccionado.rutFormato)
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null
  }
  /*********FIN MODAL CLIENTE *********/


  /********* MODAL VENDEDOR *********/
  abrirModalSeleccionarVendedor() {
    this.formHeader.get('todosVendedores').setValue(false)
    this.modalSeleccionarVendedor.show()
  }

  onVendedorSeleccionado({ data }) {
    this.vendedorSeleccionado = data
    this.formHeader.get('rutVendedor').setValue(this.rutService.AgregarDV(this.vendedorSeleccionado.rut))
  }

  onVendedorNoEncontrado() {
    this.vendedorSeleccionado = null
  }
  /*********FIN MODAL VENDEDOR *********/


  limpiarfiltros() {
    this.formValidatorsService.reset(this.formHeader)
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VISTA_RESUMEN)
    this.formHeader.get('fechaDesde').setValue(initDate)
    this.formHeader.get('fechaHasta').setValue(currentDate)
    this.formHeader.get('rutCliente').setValue('')
    this.formHeader.get('todosClientes').setValue(true)
    //this.formHeader.get('rutVendedor').setValue('')
    this.formHeader.get('todosVendedores').setValue(true)
    this.resumen_listaMovimientosAll = null;
    this.resumen_listaMovimientos = null;
    this.detalle_listaMovimientosAll = null;
    this.detalle_listaMovimientos = null;
    this.vendedorSeleccionado = null
    this.clienteSeleccionado = null
  }

  loadVendedores() {
    this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta
      this.optionsVendedores = registros.map(vendedor => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor }))
    })
  }

  /********* BÚSQUEDA RESUMEN/DETALLE *********/
  buscar(pageNumber: number) {
    this.resumenBuscar(pageNumber)
    this.detalleBuscar(pageNumber)
  }

  /********* RESUMEN *********/
  resumenBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.resumen_paginationContext.CurrentPage = pageNumber

    this.resumen_listaMovimientos = null
    this.resumen_listaMovimientosAll = null

    const { fechaDesde, fechaHasta, todosClientes, agregarFaltantes, vendedores } = this.formHeader.value
    this.log('vendedores', vendedores)

    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        cliente_proveedor_rut: this.clienteSeleccionado ? this.clienteSeleccionado.rut : 0,
        todosClientes,
        agregarFaltantes,
        listaVendedores: vendedores,
        retornaExcel: false
      },
      paginaActual: this.resumen_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.resumen_paginationContext.RecordsByPage
    }
    this.resumen_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.resumen_loading = true
    this.saldoDocumentoService.obtenerDocumentoPorCobrarClienteResumen(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.resumen_listaMovimientosAll = registros
      this.resumen_paginationContext.RecordsCount = this.resumen_listaMovimientosAll.length //totalRegistros
      this.resumen_paginationContext.PagesCount = Math.ceil(this.resumen_paginationContext.RecordsCount / this.resumen_paginationContext.RecordsByPage) //totalPaginas
      this.resumen_paginationContext.CurrentPage = 1
      this.resumen_listaMovimientosAll.forEach(mov => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      })
      this.resumen_loading = false
      this.showPageResumen(this.resumen_paginationContext.CurrentPage)
      this.calculateTotalesResumen()
    })
  }

  showPageResumen(pageNumber: number) {
    this.resumen_paginationContext.CurrentPage = pageNumber
    const start = (this.resumen_paginationContext.CurrentPage - 1) * this.resumen_paginationContext.RecordsByPage
    this.resumen_listaMovimientos = _.slice(this.resumen_listaMovimientosAll, start, start + this.resumen_paginationContext.RecordsByPage)
  }

  calculateTotalesResumen() {
    this.resumen_totales = {
      total_monto: _.sumBy(this.resumen_listaMovimientosAll, 'monto'),
      total_pago: _.sumBy(this.resumen_listaMovimientosAll, 'abono'),
      total_saldo: _.sumBy(this.resumen_listaMovimientosAll, 'saldo')
    }
  }

  resumenOnPageChange(context: PaginationContext) {
    // this.resumenBuscar(context.RequestedPage)
    this.showPageResumen(context.RequestedPage)
  }

  resumenDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.resumen_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.saldoDocumentoService.obtenerDocumentoPorCobrarClienteResumenExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].nombreArchivoExcel)
    })
  }
  /********* RESUMEN *********/

  /********* DETALLE *********/
  detalleBuscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      return
    }

    this.detalle_paginationContext.CurrentPage = pageNumber

    this.detalle_listaMovimientos = []
    const { fechaDesde, fechaHasta, todosClientes, agregarFaltantes, vendedores } = this.formHeader.value

    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        cliente_proveedor_rut: this.clienteSeleccionado ? this.clienteSeleccionado.rut : 0,
        todosClientes,
        agregarFaltantes,
        listaVendedores: vendedores,
        retornaExcel: false
      },
      paginaActual: this.detalle_paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1 //this.detalle_paginationContext.RecordsByPage
    }

    this.detalle_currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.resumen_loading = true
    this.detalle_listaMovimientos = null
    this.detalle_listaMovimientosAll = null

    this.saldoDocumentoService.obtenerDocumentoPorCobrarClienteDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.detalle_listaMovimientosAll = registros
      this.detalle_paginationContext.RecordsCount = this.detalle_listaMovimientosAll.length //totalRegistros
      this.detalle_paginationContext.PagesCount = Math.ceil(this.detalle_paginationContext.RecordsCount / this.detalle_paginationContext.RecordsByPage) //totalPaginas
      this.detalle_paginationContext.CurrentPage = 1
      this.detalle_listaMovimientosAll.forEach(mov => {
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut)
      })
      this.showPageDetalle(this.detalle_paginationContext.CurrentPage)
      this.calculateTotalesDetalles()
      this.detalle_loading = false
    })
  }

  showPageDetalle(pageNumber: number) {
    this.detalle_paginationContext.CurrentPage = pageNumber
    const start = (this.detalle_paginationContext.CurrentPage - 1) * this.detalle_paginationContext.RecordsByPage
    this.detalle_listaMovimientos = _.slice(this.detalle_listaMovimientosAll, start, start + this.detalle_paginationContext.RecordsByPage)
  }

  calculateTotalesDetalles() {
    this.detalle_totales = {
      total_monto: _.sumBy(this.detalle_listaMovimientosAll, 'monto'),
      total_pago: _.sumBy(this.detalle_listaMovimientosAll, 'abono'),
      total_saldo: _.sumBy(this.detalle_listaMovimientosAll, 'saldo')
    }
  }

  detalleOnPageChange(context: PaginationContext) {
    // this.detalleBuscar(context.RequestedPage)
    this.showPageDetalle(context.RequestedPage)
  }

  detalleDownloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.detalle_currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'

    this.log('inputParams', JSON.stringify(inputParams))

    this.saldoDocumentoService.obtenerDocumentoPorCobrarClienteDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].nombreArchivoExcel)
    })
  }

  abrirModalSeleccionDocumento() {
    //const proveedorRut = this.formHeader.get('rutProveedor').value
    this.modalSeleccionarDocumentoAjuste.load(this.clienteSeleccionado)
  }


  onDocumentoSeleccionado({ data }) {


  }

  onNotFoundDocumento() {

  }
}
